import React from 'react';

import { useRetrievalExperience } from '../../../hooks/useRetrievalExperience';
import GraphExplorer from './GraphExplorer';

const GraphPanel: React.FC = () => {
  const { state } = useRetrievalExperience();

  return (
    <section className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm">
      <header className="flex items-center justify-between border-b border-neutral-200 px-4 py-3">
        <div>
          <h3 className="text-sm font-semibold text-neutral-900">Graph Explorer</h3>
          <p className="text-[11px] text-neutral-500">Live traversal context from hybrid retrieval</p>
        </div>
        <div className="flex items-center gap-3 text-[11px] text-neutral-500">
          <span>
            Nodes <strong className="text-neutral-800">{state.graphNodes.length}</strong>
          </span>
          <span>
            Edges <strong className="text-neutral-800">{state.graphEdges.length}</strong>
          </span>
        </div>
      </header>
      <div className="min-h-0 flex-1 bg-neutral-50/60">
        <GraphExplorer />
      </div>
    </section>
  );
};

export default GraphPanel;
